<template>
   <div class="animated fadeIn">
      <b-row class="filter-row">
         <b-col sm="12">
            <b-card header-tag="header" footer-tag="footer">
               <template #header>
                  <strong>AWB {{ keyword_id }} List</strong>
                  <div class="card-header-actions">
                     <button
                        data-toggle="tooltip"
                        title="Refresh"
                        class="btn btn-sm btn-primary ml-4"
                        style="margin-right:1.5rem"
                        type="button"
                        @click="refresh"
                        >
                     <i class="fa fa-refresh"></i>
                     </button>
                  </div>
               </template>
               <b-row>
                  <b-col md="12">
                     <div class="tab-panel">
                        <b-row>
                           <b-col
                              sm="3"
                              v-if="['BookingPending', 'BookingDone', 'OFD', 'Delivered', 'NDR', 'INTransit','PartialDelivered','PickDone','HubInScanPending','HubInScan','ZoneInScan','ZoneOutScan','DispatchOutScan','RTO','RTO-DLY-SHIPPING','RTO-NC','RTO-PKUP-CAN','RTO-eWayBill-EXP','StockInward','IT-DMG','Lost'].includes(keyword_id)"
                              >
                              <b-form-group label="From Date:" :label-cols="3">
                                 <v-date-picker
                                    mode="single"
                                    input-class="dateInput"
                                    :available-dates="{ start: null, end: new Date() }"
                                    v-model="selectDateFrom"
                                    />
                              </b-form-group>
                           </b-col>
                           <b-col
                              sm="3"
                              v-if="['BookingPending', 'BookingDone', 'OFD', 'Delivered', 'NDR', 'INTransit','PartialDelivered','PickDone','HubInScanPending','HubInScan','ZoneInScan','ZoneOutScan','DispatchOutScan','RTO','RTO-DLY-SHIPPING','RTO-NC','RTO-PKUP-CAN','RTO-eWayBill-EXP','StockInward','IT-DMG','Lost'].includes(keyword_id)"
                              >
                              <b-form-group label="To Date:" :label-cols="3">
                                 <v-date-picker
                                    mode="single"
                                    input-class="dateInput"
                                    :available-dates="{ start: null, end: new Date() }"
                                    v-model="selectDateTo"
                                    />
                              </b-form-group>
                           </b-col>
                           <b-col sm="3" class="action-buttons">
                              <b-form-group label-cols-sm="2" label="Search" class="mb-0">
                                 <b-input-group>
                                    <b-form-input v-model="filter" placeholder="Type to Search" />
                                    <b-input-group-append>
                                       <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                 </b-input-group>
                              </b-form-group>
                           </b-col>
                           <b-col sm="3" class="action-buttons">
                              <b-button type="submit" size="md" variant="primary" @click="fetchDashboardData">Search</b-button>
                              &nbsp;
                              <b-button size="md" variant="danger" @click="clearData">Clear</b-button>
                              &nbsp;
                              <a :href="loadurl" target="_blank" v-if="totalRows > 0">
                                 <b-button
                                    size="md"
                                    variant="primary"
                                    @click="downlaodbookingpending"
                                    v-if="['BookingPending', 'BookingDone', 'OFD', 'Delivered', 'NDR', 'INTransit','PartialDelivered','PickDone','HubInScanPending','HubInScan','ZoneInScan','ZoneOutScan','DispatchOutScan','RTO','RTO-DLY-SHIPPING','RTO-NC','RTO-PKUP-CAN','RTO-eWayBill-EXP','StockInward','IT-DMG','Lost'].includes(keyword_id)"
                                    >
                                    Download
                                 </b-button>
                              </a>
                           </b-col>
                        </b-row>
                        <b-row>
                           <b-col sm="12" class="text-right">
                              <p>
                                 <b>Total Records : <span style="color:red;">{{ totalRows }}</span></b>
                              </p>
                           </b-col>
                        </b-row>
                        <div id="overlay">
                           <div class="loader"></div>
                        </div>
                        <div class="table-responsive">
                          <b-table
                            show-empty
                            stacked="sm"
                            :items="items"
                            :fields="fields"
                            :current-page="currentPage"
                            :filter="filter"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection"
                            @filtered="onFiltered"
                            :bordered="bordered"
                            :outlined="outlined"
                            :busy="isBusy"
                            >
                            <template #actions="row">
                              <router-link
                                  :to="'/awbShipmentlist/' + keyword_id + (idroute === 'qwik' ? '-qwik' : '') + ' ' + row.item.parentawb"
                              >
                                  <b-button
                                      size="sm"
                                      class="mr-1"
                                      v-b-tooltip.hover
                                      title="View Shipment List"
                                  >
                                      Shipment List
                                  </b-button>
                              </router-link>
                          </template>
                            <template slot="invoiceno" slot-scope="row">
                                {{ row.item.invoiceno}}
                                <br>
                                <label v-if="row.item.source" style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                {{ row.item.source}}
                                </label>                      
                                <br>
                                <label v-if="row.item.is_handoverload"  style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                {{ row.item.is_handoverload}}
                                </label>                      
                                <br>
                                <label v-if="row.item.vehicle_id"  style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                VID- {{ row.item.vehicle_id}} 
                                </label> 
                                <br>
                                <label v-if="row.item.vehicleno"  style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                VNo- {{ row.item.vehicleno}}
                                </label> 
                                <br>  
                                <label v-if="row.item.is_handoverload === 'No'  && (!row.item.ebn || row.item.ebn === '')"
                                  style="background:#ffcccc;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                EBN- Warehouse pending
                                </label>
                                <!-- When EBN exists -->
                                <label v-else
                                  style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                EBN- {{ row.item.ebn }}
                                </label>                    
                            </template>
                            <template slot="sourceaddress" slot-scope="row">
                               <span
                                    class="address-hover"
                                    v-b-tooltip.hover
                                    :title="row.item.sourceaddress"
                                  >
                                <label class="address-hover" v-b-tooltip.hover :title="row.item.sourceaddress" v-if="row.item.sourcestate" style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                State- {{ row.item.sourcestate}}
                                </label>
                                <br>
                                <label v-if="row.item.sourcecity" style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                City- {{ row.item.sourcecity}}
                                </label>
                                <br>
                                <label v-if="row.item.sourcepincode" style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                pincode-{{ row.item.sourcepincode}}
                                </label>
                                </span>
                            </template>
                            <template slot="destinationaddress" slot-scope="row">
                                <span
                                    class="address-hover"
                                    v-b-tooltip.hover
                                    :title="row.item.destinationaddress"
                                  >
                                <label v-if="row.item.destinationstate" style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                State- {{ row.item.destinationstate}}
                                </label>
                                <br>
                                <label v-if="row.item.destinationcity" style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                City- {{ row.item.destinationcity}}
                                </label>
                                <br>
                                <label v-if="row.item.destinationpincode" style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                pincode- {{ row.item.destinationpincode}}
                                </label>
                                </span>
                            </template>
                            <template slot="shipmentstatus" slot-scope="row">
                                {{row.item.shipmentstatus}}
                                <br>
                                <label v-if="row.item.delivery_mode" style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                Mode- {{ row.item.delivery_mode}}
                                </label>
                                <br>
                                <label v-if="row.item.delivery_mode" style="background:#e0e0e0;
                                  border-radius:4px;
                                  font-size:10px;
                                  font-weight:300;
                                  color:#333;
                                  display:inline-block;">
                                Load-{{ row.item.loadpotype}}
                                </label>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                  <b-spinner class="align-middle"></b-spinner>
                                  <strong>Loading...</strong>
                                </div>
                            </template>
                          </b-table>
                        </div>
                     </div>
                  </b-col>
               </b-row>
            </b-card>
         </b-col>
      </b-row>
      <b-col md="6" class="my-1" v-if="totalRows > 10">
         <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
            />
      </b-col>
   </div>
</template>
<script>
   import CONSTANTS from '@/utils/constants'
   import Utils from '@/utils'
   import auth from '@/utils/auth'
   
   export default {
     name: 'dashboardAwblist',
     data() {
       return {
         assigned: [],
         items: [],
         isBusy: false,
         fields: [
           { key: 'parentawb', label: 'Parent AWB', sortable: true, sortDirection: 'desc' },
           { key: 'invoiceno', label: 'Load ID', sortable: true, sortDirection: 'desc'},
           { key: 'sourceaddress', label: 'Source Address', sortable: true },
           { key: 'destinationaddress', label: 'Destination Address', sortable: true },
           { key: 'deliverystatus', label: 'Delivery Status', sortable: true },
           { key: 'shipmentstatus', label: 'Shipment Status', sortable: true },
           { key: 'createddate', label: 'Created Date', sortable: true },
           { key: 'lastmodifieddate', label: 'Updated Date', sortable: true },
           { key: 'actions', label: 'Actions' }
         ],
         fields1: [
           { key: 'shippingid', label: 'AWB', sortable: true, sortDirection: 'desc' },
           { key: 'pickuplocationaddress', label: 'Pickup Address', sortable: true },
           { key: 'shipaddress1', label: 'Delivery Address', sortable: true },
           { key: 'userinfo', label: 'Rider Name', sortable: true },
           { key: 'deliveryagentmobilenumber', label: 'Rider Mobile Number', sortable: true },
           { key: 'lastmodifieddate', label: 'Date', sortable: true },
           { key: 'nprreason', label: 'NPR Reason', sortable: true }
         ],
         fields2: [
           { key: 'shippingid', label: 'AWB', sortable: true, sortDirection: 'desc' },
           { key: 'pickuplocationaddress', label: 'Pickup Address', sortable: true },
           { key: 'shipaddress1', label: 'Delivery Address', sortable: true },
           { key: 'userinfo', label: 'Rider Name', sortable: true },
           { key: 'deliveryagentmobilenumber', label: 'Rider Mobile Number', sortable: true },
           { key: 'lastmodifieddate', label: 'Date', sortable: true },
           { key: 'ndrreason', label: 'NDR Reason' }
         ],
         outlined: true,
         totalRows: 0,
         bordered: true,
         selected: '',
         deliveryagentid: '',
         agentmaster: [],
         options: [],
         vendoroptions: [],
         currentPage: 1,
         perPage: 10,
         pageOptions: [5, 10, 15],
         sortBy: null,
         sortDesc: false,
         sortDirection: 'asc',
         agentfields: { text: 'name', value: 'id' },
         showSelectAll: true,
         selectDateFrom: null,
         selectDateTo: null,
         vendorid: '',
         value2: [],
         value3: [],
         subtitle: '',
         vendorlist: [],
         filter: null,
         infoModal: {
           id: 'info-modal',
           title: '',
           content: '',
           data: ''
         },
         route: [],
         keyword_id: '',
         idroute: '',
         loadurl: ''
       };
     },
     computed: {
       sortOptions() {
         return this.fields.filter(f => f.sortable).map(f => ({ text: f.label, value: f.key }));
       }
     },
    created() {
     this.id = this.$route.params.id;
   
     if (!this.id) return;
   
     const parts = this.id.split('-');
   
     // last segment is route type (normal / asn)
     this.idroute = parts.pop();
   
     // remaining joined part is the actual status
     this.keyword_id = parts.join('-');
   
     this.fetchDashboardData();
   },
     watch: {
       currentPage() {
         this.getdashboardAwblist();
       }
     },
     methods: {
       downlaodbookingpending() {
         const userdata = localStorage.getItem("userData");
         const userInfo = JSON.parse(userdata);
         const fromdate = this.selectDateFrom ? this.formatDate(this.selectDateFrom) : "";
         const formatdateto = this.selectDateTo ? this.formatDate(this.selectDateTo) : "";
         const orchivestatus = this.$route.query.status || '';
   
         const statusMap = {
           BookingPending: 'NotAssigned',
           BookingDone: 'Assigned',
           OFD: 'Ofd',
           Delivered: 'Delivered',
           NDR: 'NDR',
           INTransit: 'INTransit',
           PartialDelivered: 'PartialDelivered',
           PickDone:'PickDone',
           'HubInScanPending': 'HubInScanPending',
           'HubInScan': 'HubInScan',
           'ZoneInScan': 'ZoneInScan',
           'ZoneOutScan': 'ZoneOutScan',
           'DispatchOutScan': 'DispatchOutScan',
            RTO: 'RTO',
           'RTO-DLY-SHIPPING': 'RTO-DLY-SHIPPING',
           'RTO-NC': 'RTO-NC',
           'RTO-PKUP-CAN': 'RTO-PKUP-CAN',
           'RTO-eWayBill-EXP': 'RTO-eWayBill-EXP',
           StockInward: 'StockInward',
           'IT-DMG': 'IT-DMG',
           Lost: 'Lost'
         };
   
         const status = statusMap[this.keyword_id];
         if (!status) return;
   
         this.loadurl = `${CONSTANTS.MIGRATION_API_URL}/getCSVForAllocatedLoadsListing?page_no=${this.currentPage}&&sysusermasterid=${userInfo.sysusermasterid}&&usertype=${userInfo.user_type}&&for_status=${status}&&is_asn=${this.idroute === 'normal' ? 'NO' : 'YES'}&&order_type=${this.idroute === 'qwik' ? 'qwik' : ''}`;
         // add archive status
         if (orchivestatus) {
           this.loadurl += `&&orchivestatus=${orchivestatus}`;
         }
         if (fromdate || formatdateto) {
           this.loadurl += `&&fromdate=${fromdate}&&todate=${formatdateto}`;
         }
   
       },
   
       onFiltered(filteredItems) {
         this.totalRows = filteredItems.length;
         this.currentPage = 1;
       },
   
       downloadCSV() {
         document.getElementById("overlay").style.display = "block";
         const userdata = localStorage.getItem('userData');
         const userInfo = JSON.parse(userdata);
   
         const obj = {
           keyword: this.keyword_id,
           deliveryagentid: this.value2,
           vendor: this.value3,
           sysusermasterid: userInfo.sysusermasterid,
           hub_id: userInfo.pickuplocationmasterid
         };
   
         this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/dashboardshipmentlistcsv_advanced`, obj)
           .then(result => {
             document.getElementById("overlay").style.display = "none";
             this.$fire({
               text: result.body === "success" ? "Please Check Ur Mail For Downlod Link" : "Can not Download",
               type: result.body === "success" ? "success" : "warning",
               timer: 30000
             });
           });
       },
   
       displaydeliveryagent() {
         const userdata = localStorage.getItem('userData');
         const userInfo = JSON.parse(userdata);
         const deliveryagent = {
           sysusermasterid: userInfo.sysusermasterid,
           usertype: userInfo.user_type
         };
   
         this.$http.post(`${CONSTANTS.API_URL}/getVehicleListing`, deliveryagent)
           .then(result => {
             this.agentmaster = result.body;
             this.options = this.agentmaster.map(agent => ({
               name: `${agent.vehicle_name} - ${agent.vehicle_no}`,
               id: agent.vehicle_id
             }));
           })
           .catch(ex => console.log('error', ex));
       },
   
       fetchDashboardData() {
         this.getTotalRowCount().then(() => this.getdashboardAwblist());
       },
   
       getTotalRowCount() {
         const userdata = localStorage.getItem('userData');
         const userInfo = JSON.parse(userdata);
   
         const obj = {
           todate: this.selectDateTo ? this.formatDate(this.selectDateTo) : '',
           fromdate: this.selectDateFrom ? this.formatDate(this.selectDateFrom) : '',
           keyword: this.keyword_id,
           vehicleid: this.value2,
           is_asn: this.idroute === 'normal' ? 'NO' : 'YES',
           status: this.$route.query.status || '',
          order_type: this.idroute === 'qwik' ? 'qwik' : '',

         };
   
         return this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDashboardAwbListCount`, obj)
           .then(result => {
             this.totalRows = result.body.returnmsg === "Successful" ? result.body.totalcount || 0 : 0;
           })
           .catch(err => {
             console.error("Count API error", err);
             this.totalRows = 0;
           });
       },
   
       getdashboardAwblist() {
         const userdata = localStorage.getItem('userData');
         const userInfo = JSON.parse(userdata);
         this.isBusy = true;
   
         const fromdate = this.selectDateFrom ? this.formatDate(this.selectDateFrom) : '';
         const formatdateto = this.selectDateTo ? this.formatDate(this.selectDateTo) : '';
   
         if (formatdateto < fromdate) {
           this.$fire({
             text: "To date need to be greater than From date",
             type: "warning",
             timer: 30000
           });
           this.isBusy = false;
           return;
         }
   
         const obj = {
           todate: formatdateto,
           fromdate,
           keyword: this.keyword_id,
           vehicleid: this.value2,
           is_asn: this.idroute === 'normal' ? 'NO' : 'YES',
           status: this.$route.query.status || '',
           limit: this.perPage,
           offset: (this.currentPage - 1) * this.perPage,
          order_type: this.idroute === 'qwik' ? 'qwik' : '',

         };
   
         this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getDashboardAwbList`, obj)
           .then(result => {
             this.isBusy = false;
             this.items = result.body.returnmsg === "Successful" ? result.body.returnvalue : [];
             if (result.body.returnmsg !== "Successful") this.totalRows = 0;
           })
           .catch(ex => console.log('error', ex));
       },
   
       clearData() {
         this.value2 = [];
         this.options = [];
         this.selectDateFrom = null;
         this.selectDateTo = null;
         this.fetchDashboardData();
       },
   
       refresh() {
         this.value2 = [];
         this.fetchDashboardData();
       },
   
       formatDate(date) {
         const d = new Date(date);
         let month = "" + (d.getMonth() + 1);
         let day = "" + d.getDate();
         const year = d.getFullYear();
         if (month.length < 2) month = "0" + month;
         if (day.length < 2) day = "0" + day;
         return [year, month, day].join("-");
       }
     }
   };
</script>
<style>
/* Filters responsiveness */
.filter-row {
  align-items: flex-end;
}
.dateInput {
  width: 100%;
  min-height: 38px;
}

@media (max-width: 768px) {
  .filter-row > div {
    margin-bottom: 10px;
  }
  .hide-mobile {
    display: none !important;
  }

  .filter-row .btn {
    width: 100%;
    margin-bottom: 8px;
  }
  .action-buttons {
    flex-direction: column;
  }
   .table td {
    padding: 0.6rem;
    font-size: 13px;
  }

  .table th {
    font-size: 13px;
  }

  .table td label {
    margin-top: 4px;
  }
   .table.b-table-stacked td {
    border: none;
    padding: 8px 0;
  }

  .table.b-table-stacked tr {
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-bottom: 12px;
    padding: 10px;
    display: block;
  }
}
.table label {
  max-width: 100%;
  white-space: normal;
  word-break: break-word;
  padding: 2px 6px;
  margin: 2px 0;
}
.pagination {
    justify-content: center;
    flex-wrap: wrap;
  }
.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.card-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.card-header-actions {
  margin-top: 8px;
}

@media (max-width: 576px) {
  .card-header-actions {
    width: 100%;
    text-align: right;
  }
}
.table td {
  word-break: break-word;
  white-space: normal;
}

.table td label {
  display: inline-block;
  max-width: 100%;
}
.address-hover {
  display: inline-block;
  max-width: 180px;       /* adjust */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.addr-label {
  background: #e0e0e0;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 300;
  color: #333;
  display: inline-block;
  padding: 2px 6px;
  margin-top: 3px;
}


</style>
